import moment from 'moment-timezone'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import petrovich from 'petrovich'
import { prop } from 'ramda'

import CafeteriaPurchases from 'app/common/components/Cafeteria/CafeteriaPurchases'
import SimpleDate from 'app/common/classes/simple-date'

import {
  cafeteriaPurchasesPathMask,
  params as p,
  createPath,
  getSchoolTypeExact,
  getStudentIdExact,
  getDateExact,
  monthFormat,
  dateFormat,
  isMonthly,
} from 'app/pages/routePaths'

import selectPerson, { type Person } from '../selectPerson'

type Props = {
  params: {
    id: string
    date: string
    schoolType: string
  }
  router: {
    replace: (pathname: string) => void
    push: (pathname: string) => void
  }
}

const PurchasesPage = ({ params, router: { push } }: Props) => {
  const { t } = useTranslation('cafeteria')

  const date = getDateExact(params)
  const id = getStudentIdExact(params)
  const schoolType = getSchoolTypeExact(params)

  const person: Person = useSelector((state) => selectPerson(state, id))

  const handleChangeDate = useCallback(
    (newDate: string, newDateFormat: string, daily: boolean = false) => {
      push(
        createPath(
          {
            [p.studentId]: id,
            [p.schoolType]: schoolType,
            [p.date]: moment(newDate, newDateFormat).format(daily ? dateFormat : monthFormat),
          },
          cafeteriaPurchasesPathMask,
        ),
      )
    },
    [id, push, schoolType],
  )

  const dateType = isMonthly(date) ? 'month' : 'day'
  const simpleDate = new SimpleDate(date, isMonthly(date) ? monthFormat : dateFormat)

  const datePresentative =
    dateType === 'day'
      ? simpleDate.getStringFormatted('DD.MM.YYYY')
      : simpleDate.getStringFormatted('MMMM YYYY')

  const header = t('purchases_header', {
    name: prop('first', petrovich(person.name, 'genitive')),
    date: datePresentative.toLocaleLowerCase(),
  })

  return (
    <CafeteriaPurchases
      date={simpleDate}
      dateType={dateType}
      header={header}
      person={person}
      onChangeDate={handleChangeDate}
    />
  )
}

export default PurchasesPage
